import {
    POS_STORAGE_PROGRESS,
    POS_STORAGE,
    POS_STORAGE_EMPTY,
} from '../actions/posStorageAction';

export const posStorageReducer = (state={pos: false},action)=>{
    switch(action.type){
        case POS_STORAGE_PROGRESS:
        return action.data;
        case POS_STORAGE:
        return action.data
        case POS_STORAGE_EMPTY:
        return action.data
        default:
        return state;
    }
}